export default "__VITE_ASSET__BtUhjHD4__";